import { css, Theme } from "@emotion/react";

export const container = () => css`
    font-size: 14px;
    height: 34px;
    display: flex;
    justify-content: center;
`;

export const text = (theme: Theme) =>
    css({
        color: theme.candy.typography.secondary.color,
        marginLeft: "8px",
    });

export const inner = css`
    padding: 5px 0;
    line-height: 34px;
    text-align: center;
`;

export const error = (theme: Theme) =>
    css({
        color: theme.candy.semanticColors.danger.color,
    });
